<template>
  <div class="dashboard-wrapper">
    <!-- Desktop Version -->
    <div class="container-fluid p-4 d-none d-lg-block">
      <!-- Header Section -->
      <div class="row mb-4">
        <div class="col-12 text-center">
          <h1 class="display-6 text-white fw-bold mb-2">Dashboard</h1>
          <p class="text-white-50">Namirembe Diocese Young Christian SACCO</p>
        </div>
      </div>

      <!-- Bank Details Card -->
      <div class="row mb-4">
        <div class="col-12">
          <div class="card border-0 shadow-lg" style="background: rgba(255,255,255,0.95); backdrop-filter: blur(10px); border-radius: 16px;">
            <div class="card-body p-4">
              <div class="d-flex align-items-center mb-3">
                <div class="rounded-3 p-3 me-3" style="background: linear-gradient(135deg, #007bff, #0056b3);">
                  <i class="fas fa-university text-white fa-lg"></i>
                </div>
                <div>
                  <h5 class="card-title mb-1 fw-semibold">Bank Details</h5>
                  <p class="text-muted mb-0 small">Your banking information</p>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <div class="mb-2">
                    <small class="text-muted d-block">Bank Name</small>
                    <span class="fw-semibold">Equity Bank</span>
                  </div>
                </div>
                <div class="col-md-5">
                  <div class="mb-2">
                    <small class="text-muted d-block">Account Name</small>
                    <span class="fw-semibold">Namirembe Diocese Young Christian Sacco</span>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="mb-2">
                    <small class="text-muted d-block">Account Number</small>
                    <span class="fw-semibold">1039201443735</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Balance Cards -->
      <div class="row mb-4">
        <div class="col-12">
          <h4 class="text-white fw-semibold mb-3">Account Balances</h4>
        </div>
        <div class="col-md-4 mb-3">
          <div class="card border-0 shadow-lg h-100 position-relative" style="border-radius: 16px; overflow: hidden;">
            <div class="position-absolute top-0 start-0 w-100" style="height: 4px; background: linear-gradient(135deg, #28a745, #20c997);"></div>
            <div class="card-body p-4">
              <div class="d-flex align-items-center justify-content-between mb-3">
                <div class="rounded-3 p-2" style="background: linear-gradient(135deg, #28a745, #20c997);">
                  <i class="fas fa-piggy-bank text-white"></i>
                </div>
                <small class="text-muted">Savings Account</small>
              </div>
              <h3 class="fw-bold mb-1 text-success">UGX {{ commas(savings) }}</h3>
              <small class="text-muted">Available Balance</small>
            </div>
          </div>
        </div>
        <div class="col-md-4 mb-3">
          <div class="card border-0 shadow-lg h-100 position-relative" style="border-radius: 16px; overflow: hidden;">
            <div class="position-absolute top-0 start-0 w-100" style="height: 4px; background: linear-gradient(135deg, #007bff, #0056b3);"></div>
            <div class="card-body p-4">
              <div class="d-flex align-items-center justify-content-between mb-3">
                <div class="rounded-3 p-2" style="background: linear-gradient(135deg, #007bff, #0056b3);">
                  <i class="fas fa-chart-line text-white"></i>
                </div>
                <small class="text-muted">{{ number_of_shares }} Shares</small>
              </div>
              <h3 class="fw-bold mb-1 text-primary">UGX {{ commas(shares) }}</h3>
              <small class="text-muted">Share Value</small>
            </div>
          </div>
        </div>
        <div class="col-md-4 mb-3">
          <div class="card border-0 shadow-lg h-100 position-relative" style="border-radius: 16px; overflow: hidden;">
            <div class="position-absolute top-0 start-0 w-100" style="height: 4px; background: linear-gradient(135deg, #dc3545, #c82333);"></div>
            <div class="card-body p-4">
              <div class="d-flex align-items-center justify-content-between mb-3">
                <div class="rounded-3 p-2" style="background: linear-gradient(135deg, #dc3545, #c82333);">
                  <i class="fas fa-credit-card text-white"></i>
                </div>
                <small class="text-muted">Outstanding</small>
              </div>
              <h3 class="fw-bold mb-1 text-danger">UGX {{ commas(loans) }}</h3>
              <small class="text-muted">Loan Balance</small>
            </div>
          </div>
        </div>
      </div>

      <!-- Transactions Section -->
      <div class="row">
        <div class="col-12">
          <div class="card border-0 shadow-lg" style="background: rgba(255,255,255,0.95); backdrop-filter: blur(10px); border-radius: 16px;">
            <div class="card-body p-4">
              <div class="d-flex align-items-center justify-content-between mb-4">
                <div>
                  <h5 class="card-title mb-1 fw-semibold">Recent Transactions</h5>
                  <p class="text-muted mb-0 small">Your latest account activity</p>
                </div>
                <div class="d-flex align-items-center">
                  <label class="form-label me-2 mb-0 small text-muted">Show:</label>
                  <select v-model="items" class="form-select form-select-sm" style="width: 80px;">
                    <option value="5">5</option>
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="40">40</option>
                    <option value="80">80</option>
                  </select>
                </div>
              </div>

              <div v-if="!transactions" class="text-center py-5">
                <div class="spinner-border text-primary" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
                <p class="text-muted mt-2 small">Loading transactions...</p>
              </div>

              <div v-else class="transaction-list">
                <div v-for="(transaction, index) in transactions" :key="index" 
                     v-if="index + 1 <= items"
                     class="d-flex align-items-center p-3 rounded-3 mb-2 transaction-item"
                     :class="{'bg-light': index % 2 === 0}">
                  <div class="me-3">
                    <div class="rounded-circle d-flex align-items-center justify-content-center transaction-icon"
                         :class="getTransactionIconClass(transaction.title)">
                      <i :class="getTransactionIcon(transaction.title)"></i>
                    </div>
                  </div>
                  <div class="flex-grow-1">
                    <h6 class="mb-1 fw-semibold">{{ transaction.title }}</h6>
                    <small class="text-muted">{{ transaction.action }}</small>
                  </div>
                  <div class="text-end">
                    <small class="text-muted">{{ transaction.date_of_payment }}</small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Mobile Version -->
    <div class="container p-3 d-block d-lg-none">
      <!-- Header -->
      <div class="text-center mb-3">
        <h2 class="text-white fw-bold mb-1">Dashboard</h2>
        <p class="text-white-50 small">NDYC SACCO</p>
      </div>

      <!-- Bank Details Mobile -->
      <div class="card border-0 shadow mb-3" style="border-radius: 12px;">
        <div class="card-body p-3">
          <div class="d-flex align-items-center mb-2">
            <div class="rounded-2 p-2 me-2" style="background: linear-gradient(135deg, #007bff, #0056b3);">
              <i class="fas fa-university text-white"></i>
            </div>
            <h6 class="mb-0 fw-semibold">Bank Details</h6>
          </div>
          <div class="small">
            <div class="mb-1">
              <span class="text-muted">Bank:</span> <span class="fw-medium">Equity Bank</span>
            </div>
            <div class="mb-1">
              <span class="text-muted">Account:</span> <span class="fw-medium">Namirembe Diocese Young Christian Sacco</span>
            </div>
            <div>
              <span class="text-muted">Number:</span> <span class="fw-medium">1039201443735</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Mobile Balance Cards -->
      <div class="mb-3">
        <h5 class="text-white fw-semibold mb-3">Balances</h5>
        <div class="card border-0 shadow-sm mb-2" style="border-radius: 12px;">
          <div class="card-body p-3">
            <div class="d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <div class="rounded-2 p-2 me-3" style="background: linear-gradient(135deg, #28a745, #20c997);">
                  <i class="fas fa-piggy-bank text-white"></i>
                </div>
                <div>
                  <small class="text-muted">Savings</small>
                  <h5 class="mb-0 fw-bold text-success">UGX {{ commas(savings) }}</h5>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card border-0 shadow-sm mb-2" style="border-radius: 12px;">
          <div class="card-body p-3">
            <div class="d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <div class="rounded-2 p-2 me-3" style="background: linear-gradient(135deg, #007bff, #0056b3);">
                  <i class="fas fa-chart-line text-white"></i>
                </div>
                <div>
                  <small class="text-muted">Shares: {{ number_of_shares }}</small>
                  <h5 class="mb-0 fw-bold text-primary">UGX {{ commas(shares) }}</h5>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card border-0 shadow-sm mb-3" style="border-radius: 12px;">
          <div class="card-body p-3">
            <div class="d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <div class="rounded-2 p-2 me-3" style="background: linear-gradient(135deg, #dc3545, #c82333);">
                  <i class="fas fa-credit-card text-white"></i>
                </div>
                <div>
                  <small class="text-muted">Loans</small>
                  <h5 class="mb-0 fw-bold text-danger">UGX {{ commas(loans) }}</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Mobile Transactions -->
      <div class="card border-0 shadow" style="border-radius: 12px;">
        <div class="card-body p-3">
          <div class="d-flex align-items-center justify-content-between mb-3">
            <h6 class="mb-0 fw-semibold">Transactions</h6>
            <select v-model="items" class="form-select form-select-sm" style="width: 60px;">
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="20">20</option>
            </select>
          </div>

          <div v-if="!transactions" class="text-center py-4">
            <div class="spinner-border spinner-border-sm text-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>

          <div v-else>
            <div v-for="(transaction, index) in transactions" :key="index" 
                 v-if="index + 1 <= items"
                 class="d-flex align-items-center p-2 rounded-2 mb-2"
                 :class="{'bg-light': index % 2 === 0}">
              <div class="me-3">
                <div class="rounded-circle d-flex align-items-center justify-content-center mobile-transaction-icon"
                     :class="getTransactionIconClass(transaction.title)">
                  <i :class="getTransactionIcon(transaction.title)" style="font-size: 12px;"></i>
                </div>
              </div>
              <div class="flex-grow-1">
                <div class="fw-semibold small">{{ transaction.title }}</div>
                <div class="text-muted" style="font-size: 11px;">{{ transaction.action }}</div>
                <div class="text-muted" style="font-size: 10px;">{{ transaction.date_of_payment }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { transactionComputed, transactionMethods, savingComputed, savingMethods } from '@/state/helpers';

export default {
  name: "home",
  data() {
    return {
      items: 5,
      saving: '5000',
      shares: 0,
      number_of_shares: 0,
      loans: 0,
    }
  },

  computed: {
    ...transactionComputed,
    ...savingComputed
  },

  mounted() {
    this.dashboard();
    this.fetchTransactions();
    this.fetchSavings()
  },

  methods: {
    ...transactionMethods,
    ...savingMethods,
    commas(x) { 
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); 
    },
    
    getTransactionIcon(title) {
      const icons = {
        'Shares': 'fas fa-chart-line',
        'Savings': 'fas fa-piggy-bank',
        'Dividend': 'fas fa-percentage',
        'Interest': 'fas fa-trending-up',
        'Withdraws': 'fas fa-arrow-down'
      };
      return icons[title] || 'fas fa-exchange-alt';
    },

    getTransactionIconClass(title) {
      const classes = {
        'Shares': 'bg-primary text-white',
        'Savings': 'bg-success text-white',
        'Dividend': 'bg-info text-white',
        'Interest': 'bg-warning text-white',
        'Withdraws': 'bg-danger text-white'
      };
      return classes[title] || 'bg-secondary text-white';
    },

    async dashboard() {
      try {
        const response = await axios.get('/dashboard');
        this.shares = response.data.shares;
        this.number_of_shares = response.data.number_of_shares
        this.loans = response.data.loans;
        this.number_of_shares = response.data.number_of_shares;
      } catch (error) {
        console.log(error);
      }
    },

    async getTransactions() {
      try {
        const response = await axios.get('/mytransactions');
        this.transactions = response.data.transactions;
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style scoped>
.dashboard-wrapper {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  min-height: 100vh;
}

.transaction-icon {
  width: 40px;
  height: 40px;
  font-size: 16px;
}

.mobile-transaction-icon {
  width: 32px;
  height: 32px;
  font-size: 12px;
}

.transaction-item {
  transition: all 0.2s ease;
}

.transaction-item:hover {
  background-color: rgba(0,0,0,0.05) !important;
  transform: translateX(2px);
}

.card {
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0,0,0,0.15) !important;
}

@media (max-width: 768px) {
  .dashboard-wrapper {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  }
}
</style>